import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import EditablePriceItem from "./EditablePriceItem";
import { toast } from "react-toastify";
import { useAuth } from "../../Common/Configurations/AuthContext";
import {
  Card,
  Button,
  Row,
  Col,
  Spinner,
  ListGroup,
  Table,
} from "react-bootstrap";
import moment from "moment";
import { FaPencilAlt, FaWhatsapp } from 'react-icons/fa';
import PackageShareModal from "./PackageShareModal";




const FullPageDisplayLayout = ({ packageData, onEdit, onPriceSave }) => {
  if (!packageData?.package) {
    return <p className="text-center">No package data available.</p>;
  }

  const { package: pkg } = packageData;

  const EditButton = ({ tabIndex }) => (
    <Button variant="primary" size="sm" onClick={() => onEdit(tabIndex)}>
      <FaPencilAlt size={12} className="me-1" /> Edit
    </Button>
  );
  return (
    <div>
      <Row className="mb-4 g-4">
        <Col md={7}>
          <img
            src={pkg.imageSrc || 'https://via.placeholder.com/800x500?text=Tour+Image'}
            alt={pkg.packageName}
            className="img-fluid rounded shadow-sm"
            style={{ width: "100%", height: "350px", objectFit: "cover" }}
          />
        </Col>
        <Col md={5}>
          <Card className="h-100 shadow-sm">
            <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
              Package Summary
              <EditButton tabIndex={0} /> 
            </Card.Header>
             <div className="list-group list-group-flush">
                <div className="list-group-item"><strong>Duration:</strong> {pkg.duration}</div>
                <div className="list-group-item"><strong>Start Date:</strong> {moment(pkg.startedDate).format("MMMM Do, YYYY")}</div>
                <div className="list-group-item"><strong>Destinations:</strong> {pkg.destinationsCover}</div>

                {/* --- FIX: Removed onNavigate and tabIndex props --- */}
                <EditablePriceItem 
                    label="Flight Price" 
                    value={pkg.flightPrice} 
                    currency={pkg.currency} 
                    fieldKey="flightPrice" 
                    onSave={onPriceSave} 
                    isLive={pkg.isLive}
                />
                
                {/* --- FIX: Removed onNavigate and tabIndex props --- */}
                <EditablePriceItem 
                    label="Hotel Price" 
                    value={pkg.hotelPrice} 
                    currency={pkg.currency} 
                    fieldKey="hotelPrice" 
                    onSave={onPriceSave}
                    isLive={pkg.isLive}
                />
                
                <EditablePriceItem label="Sightseeing Price" value={pkg.sightSeeingPrice} currency={pkg.currency} fieldKey="sightSeeingPrice" onSave={onPriceSave} />
                <EditablePriceItem label="Transfer Price" value={pkg.transferPrice} currency={pkg.currency} fieldKey="transferPrice" onSave={onPriceSave} />
                <EditablePriceItem label="Other Price" value={pkg.otherPrice} currency={pkg.currency} fieldKey="otherPrice" onSave={onPriceSave} />
                <EditablePriceItem label="Purchase Price" value={pkg.purchasePrice} currency={pkg.currency} fieldKey="purchasePrice" onSave={onPriceSave} />

                <EditablePriceItem 
                  label="Sale Price" 
                  value={pkg.price} 
                  currency={pkg.currency} 
                  fieldKey="price" 
                  onSave={onPriceSave} 
                />
            </div>
          </Card>
        </Col>
      </Row>
          

      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
          Overview
          <EditButton tabIndex={0} /> 
        </Card.Header>
        <Card.Body>
          <p className="mb-0">{pkg.description}</p>
        </Card.Body>
      </Card>

      {/* --- Itinerary Section --- */}
      {packageData.itineraries?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Itinerary
            <EditButton tabIndex={1} /> 
          </Card.Header>
          <Card.Body>
            {packageData.itineraries
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((item, index) => (
                <div key={index} className="p-3 mb-3 border rounded bg-white">
                  <h6 className="fw-bold">{moment(item.date).format("MMMM Do, YYYY")} - {item.title}</h6>
                  <p className="mb-1"><strong>Location:</strong> {item.location}</p>
                  <p className="mb-1 text-muted">{item.description}</p>
                  {item.meals && <small className="d-block text-info"><strong>Meals:</strong> {item.meals}</small>}
                </div>
              ))}
          </Card.Body>
        </Card>
      )}
      {packageData.flightBookings?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Flight Details
            <EditButton tabIndex={2} /> 
          </Card.Header>
          <Card.Body>
            {packageData.flightBookings.map((flight, index) => (
              <div key={index} className="p-3 mb-3 border rounded bg-white">
                <h6 className="fw-bold">{flight.airline} - Flight {flight.flightNumber} ({flight.cabinClass})</h6>
                <Row>
                  <Col md={6}><strong>From:</strong> {flight.departureCity}</Col>
                  <Col md={6}><strong>To:</strong> {flight.arrivalCity}</Col>
                </Row>
                <Row>
                  <Col md={6}><small><strong>Departure:</strong> {moment(flight.departureDateTime).format("MMM Do, YYYY, h:mm a")}</small></Col>
                  <Col md={6}><small><strong>Arrival:</strong> {moment(flight.arrivalDateTime).format("MMM Do, YYYY, h:mm a")}</small></Col>
                </Row>
              </div>
            ))}
          </Card.Body>
        </Card>
      )}
      {packageData.hotelBookings?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Hotel Bookings
            <EditButton tabIndex={3} /> 
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr><th>Hotel</th><th>City</th><th>Check-In</th><th>Check-Out</th><th>Room Type</th></tr>
              </thead>
              <tbody>
                {packageData.hotelBookings.map((hotel, index) => (
                  <tr key={index}>
                    <td>{hotel.hotelName}</td>
                    <td>{hotel.city}</td>
                    <td>{moment(hotel.checkInDate).format("MMM Do, YYYY")}</td>
                    <td>{moment(hotel.checkOutDate).format("MMM Do, YYYY")}</td>
                    <td>{hotel.roomType}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
      {packageData.sightSeeings?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Sightseeing
            <EditButton tabIndex={4} /> 
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr><th>Date</th><th>Destination</th><th>Attraction</th><th>Description</th></tr>
              </thead>
              <tbody>
                {packageData.sightSeeings.map((sight, index) => (
                  <tr key={index}>
                    <td>{moment(sight.date).format("MMM Do, YYYY")}</td>
                    <td>{sight.destination}</td>
                    <td>{sight.sightseeingName}</td>
                    <td>{sight.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
      
      {packageData.transfers?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Transfers
            <EditButton tabIndex={5} />
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr><th>Date</th><th>Pickup Time</th><th>From</th><th>To</th><th>Vehicle</th></tr>
              </thead>
              <tbody>
                {packageData.transfers.map((transfer, index) => (
                  <tr key={index}>
                    <td>{moment(transfer.date).format("MMM Do, YYYY")}</td>
                    <td>{transfer.pickupTime}</td>
                    <td>{transfer.fromLocation}</td>
                    <td>{transfer.toLocation}</td>
                    <td>{transfer.vehicleDetails}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      )}
      <Row className="mb-4">
        {packageData.includes?.length > 0 && (
          <Col md={6}>
            <Card className="shadow-sm h-100">
              <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
                What's Included
                <EditButton tabIndex={6} /> 
              </Card.Header>
              <ListGroup variant="flush">
                {packageData.includes.map((item, index) => (
                  <ListGroup.Item key={index}>{item.description}</ListGroup.Item>
                ))}
              </ListGroup>
            </Card>
          </Col>
        )}
        {packageData.excludes?.length > 0 && (
          <Col md={6}>
            <Card className="shadow-sm h-100">
              <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
                What's Excluded
                <EditButton tabIndex={7} /> 
              </Card.Header>
              <ListGroup variant="flush">
                {packageData.excludes.map((item, index) => (
                  <ListGroup.Item key={index}>{item.description}</ListGroup.Item>
                ))}
              </ListGroup>
            </Card>
          </Col>
        )}
      </Row>
      {packageData.termsandConditions?.length > 0 && (
        <Card className="mb-4 shadow-sm">
          <Card.Header as="h5" className="bg-light d-flex justify-content-between align-items-center">
            Terms & Conditions
            <EditButton tabIndex={8} /> 
          </Card.Header>
          <Card.Body>
            {packageData.termsandConditions.map((term, index) => (
              <div key={index} className="mb-3">
                <h6 className="fw-bold">{term.title}</h6>
                <p className="text-muted mb-0">{term.description}</p>
              </div>
            ))}
          </Card.Body>
        </Card>
      )}
    </div>
  );
};
   


const PackageDetailsView = ({ packageId, onEditRequest }) => { 
  const { user } = useAuth(); // Get user from auth context
  const [packageData, setPackageData] = useState(null);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [showShareModal, setShowShareModal] = useState(false); // State for the new modal

  useEffect(() => {
    const getPackageData = async () => {
      if (packageId) {
        setIsDataLoading(true);
        try {
          const response = await apiService.get(`${config.GETPACKAGEDETAILS}/${packageId}`);
          setPackageData(response);
        } catch (error) {
          console.error("Error fetching package details:", error);
        } finally {
          setIsDataLoading(false);
        }
      } else {
        setIsDataLoading(false); 
      }
    };
    getPackageData();
  }, [packageId]);

  const handlePriceUpdate = async (fieldKey, newValue) => {
    if (!packageData || !packageData.package) return;

    // Create a full copy of the package object to update
    const updatedPkg = { ...packageData.package };
    updatedPkg[fieldKey] = parseFloat(newValue) || 0; // Update the specific price

    // --- Recalculate Total and Purchase Price for consistency ---
    const newTotal = 
        updatedPkg.flightPrice + 
        updatedPkg.hotelPrice + 
        updatedPkg.sightSeeingPrice + 
        updatedPkg.transferPrice + 
        updatedPkg.otherPrice;

    
    updatedPkg.purchasePrice = newTotal; // As per your backend logic

    try {
        // Your reference code uses FormData, so we will do the same
        const formData = new FormData();
        Object.entries(updatedPkg).forEach(([key, value]) => {
            // Handle null/undefined values correctly for FormData
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });
        
        // Ensure IDs are present for the update call
        formData.append("packageId", packageId);
        formData.append("companyId", user?.cid);
        formData.append("userId", user?.id);

        await apiService.update(config.UPDATEPACKAGE, formData);

        // Update the local state to show the change instantly
        setPackageData(prevData => ({
            ...prevData,
            package: updatedPkg
        }));

    } catch (error) {
        toast.error("Failed to update price.");
        console.error("Error updating price:", error);
    }
  };
  const handleShareClick = () => {
    // Check if the user object exists and has a whatsAppNumber
    if (user && user.whatsAppNumber) {
      // If yes, show the modal
      setShowShareModal(true);
    } else {
      // If no, show a warning toast
      toast.warn("Please add your WhatsApp number in your profile to use this feature.");
    }
  };



  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 ms-3">
          {isDataLoading ? "Loading Package..." : packageData?.package?.packageName}
        </h4>
         {!isDataLoading && packageData && (
            // --- UPDATE THE BUTTON's onClick ---
            <Button variant="success" onClick={handleShareClick} className="me-3" >
                <FaWhatsapp className="me-2" />
                Share
            </Button>
        )}
      </div>
      
     {isDataLoading ? (
        <div className="text-center p-5">
          <Spinner animation="border" />
          <p className="mt-2">Loading package details...</p>
        </div>
      ) : packageData ? (
        // --- 4. PASS THE NEW FUNCTION AS A PROP ---
        <FullPageDisplayLayout 
            packageData={packageData} 
            onEdit={onEditRequest} 
            onPriceSave={handlePriceUpdate} 
        />
      ) : (
        <div className="text-center p-5">
          <p>Could not load package details.</p>
        </div>
      )}
      {/* Render the new modal */}
      {packageData && (
          <PackageShareModal 
            show={showShareModal}
            onHide={() => setShowShareModal(false)}
            packageData={packageData}
          />
      )}
    </div>
  );
};

export default PackageDetailsView;